import * as React from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { useTheme } from "@mui/material/styles";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...(theme.palette.mode === "dark" && {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
    ...(theme.palette.mode === "dark" && {
      backgroundColor: "#308fe8",
    }),
  },
}));

export default function CustomizedProgressBars({ value }) {
  const theme = useTheme();
  return (
    <Stack
      spacing={2}
      sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <BorderLinearProgress
        sx={{
          width: "80%",
          marginRight: "10px",
          height: "5px",
          color: "red",
        }}
        variant="determinate"
        color="secondary"
        value={value > 101 ? 100 : value}
      />
      <div style={{ marginTop: 0, whiteSpace: "nowrap" }}>{value}%</div>
    </Stack>
  );
}
